import { gql } from 'apollo-angular';

export const BOOKING_EXPRESS_TRANSACTIONS = gql`
  query bookingExpressTxns($sortBy:BookingExpressSortingInput) {
    bookingExpressTxns(sortBy:$sortBy) {
      bookingExpressId
      status
      notes
      dateCreated
      startFormattedAddress
      endFormattedAddress
      partnerRating {
        rate
      }
      user {
        dateCreated
        email
        isVerify
        membershipId
        mobile
        name
        currentPoints
        usedPoints
        userId
      }
      partner {
        partnerId
        tier
        membershipId
        firstName
        middleName
        lastName
        mobile
        email
        distributionArea
        vehicleType
        licensePlate
        isOtpVerify
        isApprove
        dateCreated
        currentPoints
        usedPoints
      }
      totalPrice
      orderRoutes
      totalDistance
      discountPrice
      farePrice
    }
  }
`;

export const BOOKING_RIDE_MOTOTAXI_TRANSACTIONS = gql`
  query bookingRideTxns($service:BookingRideServiceFilterInput!, $sortBy:BookingRideSortingInput) {
    bookingRideTxns(service:$service, sortBy:$sortBy) {
      bookingRideId
      status
      dateCreated
      startFormattedAddress
      endFormattedAddress
      rating {
        rate
      }
      user {
        dateCreated
        email
        isVerify
        membershipId
        mobile
        name
        currentPoints
        usedPoints
        userId
      }
      partner {
        partnerId
        tier
        membershipId
        firstName
        middleName
        lastName
        mobile
        email
        distributionArea
        vehicleType
        licensePlate
        isOtpVerify
        isApprove
        dateCreated
        currentPoints
        usedPoints
      }
      totalPrice
      routes
      kmDistance 
      discountPrice 
      farePrice
    }
  }
`;

/** OK! Taxi — fleet bookings. Field set aligned to ride/express list + details UI. */
export const FLEET_BOOKING_TRANSACTIONS = gql`
  query fleetBookingTransactions($input: FleetBookingTransactionListInput!) {
    fleetBookingTransactions(fleetBookingTransactionListInput: $input) {
      items {
        fleetBookingId
        status
        remarks
        dateCreated
        startFormattedAddress
        endFormattedAddress
        rating {
          rate
        }
        user {
          dateCreated
          email
          isVerify
          membershipId
          mobile
          name
          currentPoints
          usedPoints
          userId
          photo
        }
        partner {
          partnerId
          tier
          membershipId
          firstName
          middleName
          lastName
          mobile
          email
          distributionArea
          vehicleType
          licensePlate
          isOtpVerify
          isApprove
          dateCreated
          currentPoints
          usedPoints
          photo
          fleetRegistry {
            fleetVehicleRegistryId
            plateNumber
            vehicleModel
            fleet {
              fleetId
              operatorName
            }
          }
        }
        fleet {
          fleetId
          operatorName
        }
        totalPrice
        routes
        kmDistance
        discountPrice
        farePrice
      }
      total
      page
      limit
      totalPages
    }
  }
`;

/** OK! Taxi — single booking details (OP2-205). */
export const FLEET_BOOKING_TRANSACTION_DETAILS = gql`
  query fleetBookingTransactionDetails($fleetBookingId: FleetBookingHashedId!) {
    fleetBookingTransactionDetails(fleetBookingId: $fleetBookingId) {
      fleetBookingId
      status
      remarks
      dateCreated
      startFormattedAddress
      endFormattedAddress
      rating {
        rate
      }
      user {
        dateCreated
        email
        isVerify
        membershipId
        mobile
        name
        currentPoints
        usedPoints
        userId
        photo
      }
      partner {
        partnerId
        tier
        membershipId
        firstName
        middleName
        lastName
        mobile
        email
        distributionArea
        vehicleType
        licensePlate
        isOtpVerify
        isApprove
        dateCreated
        currentPoints
        usedPoints
        photo
        fleetRegistry {
          fleetVehicleRegistryId
          plateNumber
          vehicleModel
          fleet {
            fleetId
            operatorName
          }
        }
      }
      fleet {
        fleetId
        operatorName
      }
      fleetVehicle {
        plateNumber
        vehicleModel
      }
      totalPrice
      routes
      kmDistance
      discountPrice
      farePrice
    }
  }
`;
